module.exports = __webpack_public_path__ + "static/media/01_FRMS-2.3-C-10 1.15ad82c3.svg";